import { Timeline as AntdTimeline } from 'antd';
import styled from 'styled-components';

export const Timeline = styled(AntdTimeline)`
    && .ant-timeline-item {
        position: relative;
        padding: 8px 0 8px 20px !important;
        border-radius: var(--border-radius-xs_4, 4px);
        transition: background 150ms;

        &:hover {
            background: var(--neutral-150, #f1f4f8);
        }
        &:active {
            background: var(--primary-200, #e7f4ff);
        }
    }

    && .ant-timeline-item.selected-item {
        background: var(--primary-100, #dceefb);
    }

    /* AntD 6 Timeline uses Steps-like DOM after bump from v5 to v6 */
    && .ant-timeline-item-wrapper {
        position: relative;
        display: grid;
        grid-template-columns: 22px 1fr;
        column-gap: 12px;
        align-items: start;
        width: 100%;
    }

    && .ant-timeline-item-icon {
        grid-column: 1;
        grid-row: 1;
        width: 22px !important;
        height: 22px !important;
        min-width: 22px !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: 0;
        box-shadow: none;
        z-index: 2;
    }

    && .ant-timeline-item-header {
        position: absolute;
        left: 6px;
        top: 3px;
        bottom: -3px;
        width: 0;
        margin: 0;
        padding: 0;
        pointer-events: none;
        z-index: 1;
    }

    && .ant-timeline-item-rail {
        display: block;
        height: 100%;
        border-inline-start: 2px solid var(--colors-border-action, #2171c6);
    }

    && .ant-timeline-item-section {
        grid-column: 2;
        grid-row: 1;
        min-width: 0;
    }

    && .ant-timeline-item-content {
        margin: 0;
        padding: 0;
        inset-block-start: 0;
    }
`;
